import React from 'react';
import { Search, User, ShoppingCart, Phone } from 'lucide-react';
export function Header() {
  return <header className="bg-cream border-b border-warmBorder sticky top-0 z-40 shadow-sm" data-id="element-525">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-526">
        <div className="flex flex-col md:flex-row items-center justify-between py-5 gap-5 md:gap-8" data-id="element-527">
          {/* Logo Area */}
          <div className="flex flex-col items-center md:items-start flex-shrink-0" data-id="element-528">
            <a href="/" className="group flex flex-col items-center md:items-start" data-id="element-529">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.switchplategallery.com/uploaded/images/header/logo.png" alt="Switchplate Gallery" className="h-14 md:h-16 w-auto object-contain" data-id="element-530" />
              <span className="text-[11px] md:text-xs font-sans tracking-[0.2em] text-warmGray uppercase mt-1.5 font-medium" data-id="element-531">
                Decorative Light Switch Plates & Outlet Covers
              </span>
            </a>
          </div>

          {/* Search Bar */}
          <div className="w-full max-w-2xl flex-1" data-id="element-532">
            <form className="relative group" onSubmit={e => e.preventDefault()} data-id="element-533">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-534">
                <Search className="h-5 w-5 text-warmGray group-focus-within:text-gold transition-colors" data-id="element-535" />
              </div>
              <input type="text" className="block w-full pl-12 pr-24 py-3.5 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all shadow-sm text-base" placeholder="Search switchplates…" data-id="element-536" />
              <button type="submit" className="absolute inset-y-1.5 right-1.5 px-5 bg-cream-dark hover:bg-gold hover:text-white text-charcoal text-sm font-bold rounded-sm transition-colors" data-id="element-537">
                Search
              </button>
            </form>
          </div>

          {/* Utilities */}
          <div className="flex items-center space-x-6 flex-shrink-0" data-id="element-538">
            <div className="hidden xl:flex flex-col items-end mr-2" data-id="element-539">
              <span className="text-xs text-warmGray font-medium uppercase tracking-wider mb-0.5" data-id="element-540">
                Need Help?
              </span>
              <a href="tel:8004976946" className="flex items-center text-charcoal hover:text-gold transition-colors font-bold text-sm" data-id="element-541">
                <Phone size={14} className="mr-1.5 text-gold" data-id="element-542" />
                800.497.6946
              </a>
            </div>

            <a href="/account" className="flex flex-col items-center text-warmGray hover:text-gold transition-colors group" data-id="element-543">
              <User className="h-6 w-6 mb-1 group-hover:scale-110 transition-transform" data-id="element-544" />
              <span className="text-xs font-bold" data-id="element-545">My Account</span>
            </a>

            <a href="#/checkout" className="flex flex-col items-center text-warmGray hover:text-gold transition-colors group relative" data-id="element-546">
              <div className="relative" data-id="element-547">
                <ShoppingCart className="h-6 w-6 mb-1 group-hover:scale-110 transition-transform" data-id="element-548" />
                <span className="absolute -top-1.5 -right-2.5 bg-gold text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center" data-id="element-549">
                  0
                </span>
              </div>
              <span className="text-xs font-bold" data-id="element-550">Cart</span>
            </a>

            <a href="#/checkout" className="hidden lg:flex items-center justify-center px-6 py-3 bg-gold text-white hover:bg-gold-dark font-bold text-sm rounded-sm transition-colors shadow-sm" data-id="element-551">
              Checkout
            </a>
          </div>
        </div>
      </div>
    </header>;
}